var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SelfService"}},[_c('Hero',{attrs:{"src":"../../assets/selfService/hero.jpg"}},[_c('h1',[_vm._v("Savitarna")])]),_c('router-view',{staticClass:"self-service-view"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }